import { Injectable, EventEmitter } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { ObjectUtils,StringUtils, Url } from '@ark-libs/ngx-utils';

import { CoreConfigService } from '../config/core-config.service';
import { Principal } from '../auth/principal.service';

@Injectable({ providedIn:'root' })
export class UserStorageService {

    private _inMemUserStorageKey = null;
    private _inMemUserStorage = {};

    dataChange: EventEmitter<{ key:string, value: any}> = new EventEmitter();

    constructor(
        private localStorage: LocalStorageService,
        private configService: CoreConfigService,
        private principal: Principal
    ) {
        // this.principal.authenticationStateChange.subscribe(account=>{
        //     this.forceEmitEvent();
        // });
    }

    private get userStorageKey():string{
        let userId = this.principal.authenticatedUserId;
        if(userId == null) userId = 0;
        return `UserStorage[${userId}]`;
    }
    private getUserStorage(): any{
        const storageKey = this.userStorageKey;
        if(storageKey == this._inMemUserStorageKey) return this._inMemUserStorage;

        this._inMemUserStorageKey = storageKey;
        try{
            let data = this.localStorage.retrieve(storageKey);
            if(!(data instanceof Object)) data = (this.configService.isDevMode?data:JSON.parse(StringUtils.uncompile(data)));
            this._inMemUserStorage = data||{};
        }catch(e){
            this._inMemUserStorage = {};
        }

        return this._inMemUserStorage;
    }
    private storeUserStorage(data:any){
        this.localStorage.store(this.userStorageKey, 
            (this.configService.isDevMode?data:StringUtils.compile(JSON.stringify(data)))
        );
    }

    get(key:string) {
    	return this.getUserStorage()[key];
    }
    put(key:string, value: any) {
        const storage = this.getUserStorage();
        const doEmit = ObjectUtils.isNotEquals(storage[key],value);
        // console.log(doEmit, storage[key], value);

        storage[key]=value;
        this.storeUserStorage(storage);

        if(doEmit) this.dataChange.emit({key:key, value:value});
    }
    
    getCurrentApp(): {id?:number, name?:string, label?:string, fullDisplayName?:string} {
        const app = this.get("currentApp");
        return (app&&(app.__init_base_url == null||app.__init_base_url==this.getCurrentBaseUrl())) ? app:null;
    }
    setCurrentApp(app:any){
        if(app)app.__init_base_url = this.getCurrentBaseUrl();
        this.put("currentApp", app);
    }
    getCurrentOffice(): {id?:number, code?:string, name?:string, fullName?:string, officeType?:string}{
        return this.get("currentOffice");
    }
    setCurrentOffice(office:any){
        this.put("currentOffice", office);
    }
    getCurrentOfficeLevel():string{
        const office = this.getCurrentOffice();
        return office?office.officeType:null;
    }

    private getCurrentBaseUrl(){
        let url:any = Url.parse();
        return url.protocol + '//' + url.host + (url.port == '80' ? '' : ':' + url.port)
            + (url.pathname!=null&&url.pathname.startsWith("/")?'':'/') + url.pathname;
    }
}